import { useMemo } from "react";
import HistoryModal from "../HistoryModal/HistoryModal";
import IconButton from "../IconButton";
import useElementHistoryController from "./useElementHistoryController";
import HistorySelectedItem from "../HistoryModal/HistorySelectedItem";

export default function ElementHistory({ hoverTipText, elementId, sourceTable, listLabel, restore, projectId, controller }) {
  const internalHistory = useElementHistoryController({
    elementId,
    sourceTable,
    projectId,
    restore,
    listLabel,
  });
  const history = controller || internalHistory;

  const selectedItem = useMemo(() => {
    const id = history.selectedSnapshot?.id;
    return (
      <HistorySelectedItem
        key={id}
        snapshot={history.selectedSnapshot}
        projectId={projectId}
      />
    );
  }, [history.selectedSnapshot, projectId]);

  return (
    <>
      <IconButton
        className="history"
        onClick={() => history.open()}
        src="/assets/clock.svg"
        ariaLabel="Open History"
        hoverTipText={hoverTipText || "Element History"}
        iconSize={20}
      />
      <HistoryModal
        isOpen={history.modalProps.isOpen}
        onClose={history.modalProps.onClose}
        selectedItem={selectedItem}
        historyItems={[]}
        onSelectItem={history.setSelectedSnapshot}
        onRestoreItem={history.modalProps.onRestoreItem}
        titleIcon="/assets/clock.svg"
        title={listLabel}
        selectedItemId={history.selectedSnapshot?.id}
        sourceTable={sourceTable}
        loading={history.modalProps.loading}
        restoring={history.modalProps.restoring}
        fetchHistory={history.fetchHistory}
        usePagination={true}
        isCreatingSnapshot={history.modalProps.isCreatingSnapshot}
      />
    </>
  );
}
